/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".power_off[_ngcontent-%COMP%]{background:0 0;outline:0;border:0;cursor:pointer}.selected-list[_ngcontent-%COMP%]   .c-btn[_ngcontent-%COMP%]{width:300px!important;height:36px}"];
export { styles as styles };
